import React, { useEffect, useState } from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import {ReactComponent as CloseIcon} from '../../../../../media/felsv/dark_close_icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { comprobanteRetencionFisicoOpenModal } from '../../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'
import { getDateOperacionMes } from '../../../../../utils/stringDate'
import { DICCIONARIO } from '../../../../../constants/Diccionario'
import SearchSelect from '../../../../../components/Inputs/SearchSelect'
import { State } from '../../../../../reducers'
import { bindActionCreators } from 'redux'
import { actionComprobanteRetencionProducto } from '../../../../../actions/action-creators'

const CREAgregarDocumento = () => {
  const edit = useSelector((state: State) => state.comprobanteRetencion.fisico.edit)
  const dispatch = useDispatch()
  return (
    <ModalBase Styles={{minWidth: "50%"}}>
      <div className='modal-error-buttons-fixed-top' style={{padding:"2%", backgroundColor:"white", zIndex:1000}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', }} >
          <h3 className='card-title l'>{edit ? "Editar" : "Agregar"} Documento Físico</h3>
          <button style={{backgroundColor: '#FFFFFF'}}  onClick={() => dispatch(comprobanteRetencionFisicoOpenModal(false))} ><CloseIcon width={35} height={35} /></button>
        </div>
      </div>
      <div className='modal-content' style={{width:"100%", padding:"1% 2.5%",}}>
        <div className='form-separator'></div>
        <CREFrom />
      </div>
    </ModalBase>
  )
}


const CREFrom = () => {
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
  const {form, errorForm, edit} = useSelector((state: State) => state.comprobanteRetencion.fisico)
  const [tiposDocs, setTiposDocs] = useState<Array<any>>([])
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionComprobanteRetencionProducto, dispatch)

  useEffect(() => {
    if(tipoDocumentosEmision.length > 0) setTiposDocs(tipoDocumentosEmision.filter((el) => el.codigodocumento === "01" || el.codigodocumento === "03"))
  }, [tipoDocumentosEmision]) 

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.creFormAgregarFisicoHandleChangeInput(e)
    acciones.creAgregarFisicoOnBlur(e)
  }

  const submit = async(e: any) => {
    e.preventDefault();
    const flag:any = await acciones.creFisicoValidacionesOnSubmit()
    if(flag === true) return;
    acciones.creAgregarDocFisico();
  }

  const cancelar = () => {
    if(!edit) acciones.comprobanteRetencionFisicoClear()
    else dispatch(comprobanteRetencionFisicoOpenModal(false))
  }

  return (    
    <div className='w-form'>
    <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' onSubmit={submit}>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='numId' className='field-label m'>Número de documento<span style={{color: 'red'}}>*</span></label>
          <input autoFocus autoComplete='off' type='text' className='m text-field w-input' maxLength={40} data-name='numId' placeholder="Número de documento" id='numId' name='numId' value={form.numId} onChange={handleChange} onBlur={acciones.creAgregarFisicoOnBlur}/>
           {errorForm.numId && <p className='alert s'>{errorForm.numId}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='tipo' className='field-label m'>{DICCIONARIO.TIPO_DTE}<span style={{color: 'red'}}>*</span></label>
          <SearchSelect defaultValue={null} placeholder={DICCIONARIO.TIPO_DTE} data={tiposDocs}  value={form.tipo}  name='tipo'  keyNameText='nombre'  keyNameValue='codigodocumento'  disabled={false}  placement="bottom"onChange={(value: any) => { handleChange({target: {value: value?.value, name: 'tipo'}})}} onBlur={acciones.creAgregarFisicoOnBlur}/>
          {errorForm.tipo && <p className='alert s'>{errorForm.tipo}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='fecha' className='field-label m'>Fecha de generación<span style={{color: 'red'}}>*</span></label>
          <input autoComplete='off' type='date' className='m text-field w-input' maxLength={10} data-name='fecha' placeholder="Fecha Inicial" id='fecha' name='fecha'  min={getDateOperacionMes(-3)} max={getDateOperacionMes(0)} value={form.fecha} onChange={handleChange} onBlur={acciones.creAgregarFisicoOnBlur}/>
           {errorForm.fecha && <p className='alert s'>{errorForm.fecha}</p>}
        </div>
      </div>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='descripcion' className='field-label m'>Descripción</label>
          <input autoComplete='off' type='text' className='m text-field w-input' maxLength={50} data-name='descripcion' placeholder="Descripción" id='descripcion' name='descripcion' value={form.descripcion} onChange={handleChange} onBlur={acciones.creAgregarFisicoOnBlur}/>
           {errorForm.descripcion && <p className='alert s'>{errorForm.descripcion}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='monto' className='field-label m'>Monto sujeto a retención<span style={{color: 'red'}}>*</span></label>
          <input autoComplete='off' type='text' className='m text-field w-input' maxLength={50} data-name='monto' placeholder="Monto sujeto a retención" id='monto' name='monto' value={form.monto} onChange={handleChange} onBlur={acciones.creAgregarFisicoOnBlur}/>
           {errorForm.monto && <p className='alert s'>{errorForm.monto}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='retencion' className='field-label m'>Monto IVA retenido</label>
          <input disabled autoComplete='off' type='text' className='m text-field w-input' maxLength={50} data-name='retencion' placeholder="Monto IVA retenido" id='retencion' name='retencion' value={form.retencion} onChange={handleChange} onBlur={acciones.creAgregarFisicoOnBlur}/>
           {errorForm.retencion && <p className='alert s'>{errorForm.retencion}</p>}
        </div>
      </div>
      <div className='w-layout-hflex button-actions'>
        <button type='button' className='m button transparent w-inline-block' onClick={cancelar}><div>{ edit ? 'Cancelar' :  'Limpiar'}</div></button>
        <button type='submit' className='m button w-inline-block'><div>{ edit ? 'Actualizar' : 'Agregar'}</div></button>
      </div>
    </form>
  </div>
  )
}

export default CREAgregarDocumento
